<template>
  <section id="descripcion-section" class="catalogo-premium">
    
    <!-- FONDO CON EFECTO PARALLAX -->
    <div class="catalogo-bg"></div>
    <div class="catalogo-overlay"></div>

    <!-- CANVAS GALÁCTICO CON EVENTOS MÁGICOS DE EXPLOSIÓN -->
    <canvas ref="canvasDestellos" class="catalogo-destellos"></canvas>

    <!-- HEADER -->
    <div class="catalogo-header">
      <span class="catalogo-tag">Colección Exclusiva</span>

      <h2 class="catalogo-title">
        Diseños que hacen <br />
        <span>inolvidable tu gran día</span>
      </h2>

      <p class="catalogo-subtitle">
        Cada invitación está diseñada para emocionar desde el primer clic.
      </p>
    </div>

    <!-- GRID RESPONSIVO (2 COLUMNAS EN MÓVIL) -->
    <div class="catalogo-grid">

      <!-- CARD INTERACTIVA CON EXPLOSIÓN DE CHISPAS MÁGICAS AL TOQUE -->
      <div
        v-for="(item, index) in invitaciones"
        :key="index"
        class="catalogo-card"
        @touchstart="lanzarMagiaTouch($event)"
      >
        <!-- Imagen o Video -->
        <div class="card-image-wrapper">
          
          <!-- SI ES VICTORIA ARRIAGA, CORRE VIDEO DE FORMA CONTROLADA -->
          <video
            v-if="item.nombre === 'Victoria Arriaga'"
            ref="videoVictoria"
            src="@/assets/nicol.mp4"
            class="card-image video-premium"
            loop
            muted
            playsinline
            autoplay
          ></video>

          <!-- SI NO, RENDERIZA LA IMAGEN NORMAL -->
          <img
            v-else
            :src="item.imagen"
            class="card-image"
            :alt="item.nombre"
            loading="lazy"
          />

          <div class="card-overlay"></div>

          <!-- BADGE -->
          <div class="card-badge">
            Premium
          </div>
        </div>

        <!-- INFO -->
        <div class="card-content">
          <h3 class="card-title">
            {{ item.nombre }}
          </h3>

          <p class="card-description">
            {{ item.descripcion }}
          </p>

          <!-- BOTÓN PRINCIPAL VER INVITACIÓN -->
          <button class="btn-ver-invitacion" @click.stop="verDemo(item)">
            Ver Invitación
          </button>

          <!-- BOTÓN INFERIOR DE PRECIOS -->
          <button class="btn-ver-precios" @click.stop="irAPrecios">
            Ver Precios
          </button>
        </div>
      </div>

    </div>

  </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'CatalogoInvitacionesPremium',

  setup() {
    const canvasDestellos = ref(null)
    const videoVictoria = ref(null)
    let animationFrameId = null
    let resizeObserver = null

    // Arrays para el sistema de partículas del Canvas
    let estrellasFijas = []
    let estrellasGlitter = []
    let particulasMagicas = []

    const invitaciones = ref([
      {
        nombre: 'Melanie',
        descripcion: 'Elegancia moderna con detalles rosas y animaciones mágicas.',
        imagen: require('@/assets/IMG_8743.webp'),
        urlDemo: 'https://melanie.myevento-digital.com/ym/53/8788'
      },
      {
        nombre: 'Victoria Arriaga',
        descripcion: 'Diseño cinematográfico con efectos premium y transiciones suaves.',
        imagen: null,
        urlDemo: 'https://victoriaarriaga.myevento-digital.com/ym/246/8788'
      },
      {
        nombre: 'Valerie',
        descripcion: 'Inspirado en lujo y glamour para una noche inolvidable.',
        imagen: require('@/assets/AP6A1932E.webp'),
        urlDemo: 'https://valerie.myevento-digital.com/ym/199/8788'
      },
      {
        nombre: 'Kamilah Zoe',
        descripcion: 'Diseño femenino con animaciones elegantes y experiencia inmersiva.',
        imagen: require('@/assets/por.webp'),
        urlDemo: 'https://kamilahzoe.myevento-digital.com/ym/53/8788'
      },
      {
        nombre: 'Johanna',
        descripcion: 'Inspiración moderna tipo revista digital premium.',
        imagen: require('@/assets/NIK_4222.webp'),
        urlDemo: 'https://johanna.myevento-digital.com/ym/53/8788'
      },
      {
        nombre: 'Aillen Morgan',
        descripcion: 'Detalles brillantes y experiencia visual impactante.',
        imagen: require('@/assets/portadaailen.webp'),
        urlDemo: 'https://ailleenmorgan.myevento-digital.com/ym/53/8788'
      },
      {
        nombre: 'Alisson Nicole',
        descripcion: 'Detalles brillantes y experiencia visual impactante.',
        imagen: require('@/assets/nuevafoto.jpg'),
        urlDemo: 'https://allison.myevento-digital.com/ym/217/8788'
      },
      {
        nombre: 'Arianna Bella',
        descripcion: 'Detalles brillantes y experiencia visual impactante.',
        imagen: require('@/assets/IMG_3644.webp'),
        urlDemo: 'https://arianna.myevento-digital.com/ym/53/8788'
      },
      {
        nombre: 'Nicole Rivera',
        descripcion: 'Detalles brillantes y experiencia visual impactante.',
        imagen: require('@/assets/9.jpg'),
        urlDemo: 'https://nicolerivera.myevento-digital.com/ym/243/8788'
      },
      {
        nombre: 'Brianna Nicole',
        descripcion: 'Detalles brillantes y experiencia visual impactante.',
        imagen: require('@/assets/_DSC3449.webp'),
        urlDemo: 'https://briannanicole.myevento-digital.com/ym/53/8788'
      }, 
      {
        nombre: 'Luisa Fernanda',
        descripcion: 'Nuevo Demo',
        imagen: require('@/assets/M1.webp'),
        urlDemo: 'https://luisafernanda.myevento-digital.com/ym/53/8788'
      },
      {
        nombre: 'Kimberly',
        descripcion: 'Invitación Dorada sin fotos.',
        imagen: require('@/assets/nuevafoto22.jpg'),
        urlDemo: 'https://kimberly.myevento-digital.com/ym/53/8788'
      },
    ])

    const reproducirVideoGlobal = () => {
      const vid = Array.isArray(videoVictoria.value) ? videoVictoria.value[0] : videoVictoria.value
      if (vid && vid.paused) {
        vid.play().then(() => {
          window.removeEventListener('touchstart', reproducirVideoGlobal)
          window.removeEventListener('click', reproducirVideoGlobal)
        }).catch(() => {})
      }
    }

    const irAPrecios = () => {
      const seccion = document.getElementById('precios-section')
      if (seccion) {
        seccion.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    }

    const verDemo = (item) => {
      if (item.urlDemo && item.urlDemo !== '#') {
        window.open(item.urlDemo, '_blank')
      }
    }

    const lanzarMagiaTouch = (e) => {
      gsap.timeline()
        .to(e.currentTarget, { scale: 0.96, duration: 0.15, ease: 'power1.out' })
        .to(e.currentTarget, { scale: 1, duration: 0.4, ease: 'power2.out' })

      const touch = e.touches[0]
      const canvas = canvasDestellos.value
      if (!canvas || !touch) return

      const rect = canvas.getBoundingClientRect()
      const touchX = touch.clientX - rect.left
      const touchY = touch.clientY - rect.top

      const cantidadChispas = 30
      for (let i = 0; i < cantidadChispas; i++) {
        const angulo = Math.random() * Math.PI * 2
        const velocidad = Math.random() * 4 + 1.5 

        particulasMagicas.push({
          x: touchX,
          y: touchY,
          vx: Math.cos(angulo) * velocidad,
          vy: Math.sin(angulo) * velocidad - Math.random() * 1.5,
          size: Math.random() * 2.5 + 1,
          alpha: 1,
          decay: Math.random() * 0.02 + 0.015,
          colorRiddle: Math.random() > 0.4 ? '#f0b2bc' : '#fff3f5'
        })
      }
    }

    const initCosmosCompleto = () => {
      const canvas = canvasDestellos.value
      if (!canvas) return
      const ctx = canvas.getContext('2d')

      let width = 0
      let height = 0

      const crearNuevaEstrellaGlitter = () => {
        return {
          x: Math.random() * width,
          y: Math.random() * height,
          maxSize: Math.random() * 2.5 + 1.2,
          currentSize: 0.1,
          alpha: 0,
          maxAlpha: Math.random() * 0.7 + 0.3,
          speed: Math.random() * 0.025 + 0.01,
          fase: 'fadeIn'
        }
      }

      const estructurarUniverso = () => {
        estrellasFijas = []
        estrellasGlitter = []
        particulasMagicas = []

        const numFijas = width < 768 ? 40 : 90
        const numGlitterInicial = width < 768 ? 25 : 50

        for (let i = 0; i < numFijas; i++) {
          estrellasFijas.push({
            x: Math.random() * width,
            y: Math.random() * height,
            size: Math.random() * 1.2 + 0.4,
            speed: Math.random() * 0.03 + 0.01,
            fase: Math.random() * Math.PI
          })
        }

        for (let i = 0; i < numGlitterInicial; i++) {
          estrellasGlitter.push(crearNuevaEstrellaGlitter())
        }
      }

      const ajustarDimensiones = () => {
        const contenedor = canvas.parentElement
        if (!contenedor) return
        width = canvas.width = contenedor.clientWidth
        height = canvas.height = contenedor.clientHeight
        estructurarUniverso()
      }

      resizeObserver = new ResizeObserver(() => {
        ajustarDimensiones()
      })
      resizeObserver.observe(canvas.parentElement)
      ajustarDimensiones()

      const animate = () => {
        ctx.clearRect(0, 0, width, height)

        // 1. CAPA INFERIOR
        estrellasFijas.forEach((estrella) => {
          estrella.fase += estrella.speed
          let brillo = (Math.sin(estrella.fase) + 1) / 2
          ctx.beginPath()
          ctx.arc(estrella.x, estrella.y, estrella.size, 0, Math.PI * 2)
          ctx.fillStyle = `rgba(255, 255, 255, ${0.15 + brillo * 0.5})`
          ctx.fill()
        })

        // 2. CAPA INTERMEDIA
        for (let i = estrellasGlitter.length - 1; i >= 0; i--) {
          let star = estrellasGlitter[i]

          if (star.fase === 'fadeIn') {
            star.alpha += star.speed
            star.currentSize += (star.maxSize - star.currentSize) * 0.1
            if (star.alpha >= star.maxAlpha) {
              star.alpha = star.maxAlpha
              star.fase = 'fadeOut'
            }
          } else if (star.fase === 'fadeOut') {
            star.alpha -= star.speed * 0.6
            if (star.alpha <= 0) {
              estrellasGlitter[i] = crearNuevaEstrellaGlitter()
              continue
            }
          }

          ctx.beginPath()
          ctx.arc(star.x, star.y, star.currentSize, 0, Math.PI * 2)
          ctx.fillStyle = `rgba(240, 178, 188, ${star.alpha})`
          ctx.shadowBlur = star.alpha * 10
          ctx.shadowColor = '#f0b2bc'
          ctx.fill()
        }

        // 3. EXPLOSIÓN DE CHISPAS
        for (let i = particulasMagicas.length - 1; i >= 0; i--) {
          let p = particulasMagicas[i]

          p.x += p.vx
          p.y += p.vy
          p.vy += 0.06
          p.alpha -= p.decay

          if (p.alpha <= 0) {
            particulasMagicas.splice(i, 1)
            continue
          }

          ctx.beginPath()
          ctx.arc(p.x, p.y, p.size * p.alpha, 0, Math.PI * 2)
          ctx.fillStyle = p.colorRiddle
          ctx.shadowBlur = p.alpha * 14
          ctx.shadowColor = p.colorRiddle
          ctx.fill()
        }

        ctx.shadowBlur = 0
        animationFrameId = requestAnimationFrame(animate)
      }

      animate()
    }

    onMounted(async () => {
      await nextTick()
      initCosmosCompleto()

      // Listeners globales para forzar reproducción en móvil tras interacción del usuario
      window.addEventListener('touchstart', reproducirVideoGlobal, { passive: true })
      window.addEventListener('click', reproducirVideoGlobal, { passive: true })

      // Intento inicial directo
      reproducirVideoGlobal()

      // Animación del Header
      gsap.from('.catalogo-header', {
        scrollTrigger: {
          trigger: '.catalogo-header',
          start: 'top 90%'
        },
        opacity: 0,
        y: 30,
        duration: 1,
        ease: 'power2.out'
      })

      // Parallax del Fondo
      gsap.to('.catalogo-bg', {
        scrollTrigger: {
          trigger: '.catalogo-premium',
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        },
        yPercent: 15,
        ease: 'none'
      })

      // Control responsive con GSAP MatchMedia
      const mm = gsap.matchMedia()

      // MÓVIL: Animación progresiva al hacer scroll
      mm.add('(max-width: 767px)', () => {
        const cards = gsap.utils.toArray('.catalogo-card')
        cards.forEach((card) => {
          gsap.fromTo(card, 
            {
              opacity: 0,
              y: 45,
              scale: 0.94
            },
            {
              scrollTrigger: {
                trigger: card,
                start: 'top 90%',
                toggleActions: 'play none none reverse'
              },
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 0.7,
              ease: 'power3.out',
              clearProps: 'transform'
            }
          )
        })
      })

      // DESKTOP: Entrada escalonada por grid
      mm.add('(min-width: 768px)', () => {
        const cards = gsap.utils.toArray('.catalogo-card')
        cards.forEach((card, i) => {
          gsap.fromTo(card,
            {
              opacity: 0,
              y: 50,
              scale: 0.95
            },
            {
              scrollTrigger: {
                trigger: card,
                start: 'top 85%',
                toggleActions: 'play none none reverse'
              },
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 0.8,
              delay: (i % 3) * 0.12,
              ease: 'power3.out',
              clearProps: 'transform'
            }
          )
        })
      })
    })

    onBeforeUnmount(() => {
      window.removeEventListener('touchstart', reproducirVideoGlobal)
      window.removeEventListener('click', reproducirVideoGlobal)
      cancelAnimationFrame(animationFrameId)
      if (resizeObserver) {
        resizeObserver.disconnect()
      }
    })

    return {
      invitaciones,
      verDemo,
      irAPrecios,
      lanzarMagiaTouch,
      canvasDestellos,
      videoVictoria
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&family=Montserrat:wght@300;400;500;600&display=swap');

/* ===== CONTENEDOR PRINCIPAL ===== */
.catalogo-premium {
  position: relative;
  width: 100%;
  padding: 90px 20px;
  background-color: #0d0a0b;
  overflow: hidden;
  color: #ffffff;
}

/* FONDO PARALLAX */
.catalogo-bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 20%, #2a1619 0%, #0d0a0b 80%);
  z-index: 1;
}

.catalogo-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(13,10,11,0.6) 0%, rgba(13,10,11,0.95) 100%);
  z-index: 2;
}

/* CANVAS DE CHISPAS */
.catalogo-destellos {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 3;
}

/* HEADER */
.catalogo-header {
  position: relative;
  z-index: 4;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 60px;
}

.catalogo-tag {
  display: inline-block;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 4px;
  color: #f0b2bc;
  margin-bottom: 12px;
}

.catalogo-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(32px, 5vw, 48px);
  font-weight: 400;
  line-height: 1.2;
  margin: 0 0 16px;
  color: #ffffff;
}

.catalogo-title span {
  font-style: italic;
  color: #f0b2bc;
}

.catalogo-subtitle {
  font-family: 'Montserrat', sans-serif;
  font-size: 15px;
  font-weight: 300;
  color: #c2b5b7;
  margin: 0;
}

/* GRID DE TARJETAS (DESKTOP) */
.catalogo-grid {
  position: relative;
  z-index: 4;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

/* TARJETA */
.catalogo-card {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(240, 178, 188, 0.15);
  border-radius: 16px;
  overflow: hidden;
  backdrop-filter: blur(10px);
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  user-select: none;
  will-change: transform, opacity;
}

@media (min-width: 768px) {
  .catalogo-card:hover {
    transform: translateY(-8px);
    border-color: rgba(240, 178, 188, 0.5);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  }

  .catalogo-card:hover .card-image {
    transform: scale(1.06);
  }
}

/* CONTENEDOR DE IMAGEN / VIDEO */
.card-image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 5;
  overflow: hidden;
  background: #1a1214;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.video-premium {
  object-fit: cover;
}

.card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(13,10,11,0.85) 100%);
}

/* BADGE */
.card-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(13, 10, 11, 0.75);
  border: 1px solid rgba(240, 178, 188, 0.3);
  color: #f0b2bc;
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 999px;
  backdrop-filter: blur(4px);
}

/* TEXTO DE LA TARJETA */
.card-content {
  padding: 16px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-title {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  margin: 0;
}

.card-description {
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 1.4;
  color: #a39598;
  margin: 0;
}

/* BOTÓN VER INVITACIÓN (CLARO Y DIRECTO) */
.btn-ver-invitacion {
  width: 100%;
  padding: 10px 0;
  background: #ffffff;
  color: #0d0a0b;
  border: none;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  margin-top: 4px;
}

.btn-ver-invitacion:hover {
  background: #f0b2bc;
  color: #ffffff;
}

/* BOTÓN INFERIOR VER PRECIOS */
.btn-ver-precios {
  width: 100%;
  padding: 8px 0;
  background: transparent;
  color: #f0b2bc;
  border: 1px dashed rgba(240, 178, 188, 0.4);
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-ver-precios:hover {
  background: rgba(240, 178, 188, 0.15);
  border-color: #f0b2bc;
}

/* ===== AJUSTES RESPONSIVOS MÓVIL (2 COLUMNAS) ===== */
@media (max-width: 767px) {
  .catalogo-premium {
    padding: 50px 12px;
  }

  .catalogo-header {
    margin-bottom: 35px;
  }

  /* Grid en 2 columnas */
  .catalogo-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  /* Tarjeta más compacta */
  .catalogo-card {
    border-radius: 12px;
  }

  .card-image-wrapper {
    aspect-ratio: 3 / 4;
  }

  .card-badge {
    top: 8px;
    right: 8px;
    font-size: 8px;
    padding: 3px 6px;
    letter-spacing: 1px;
  }

  .card-content {
    padding: 10px 8px 12px;
    gap: 6px;
  }

  .card-title {
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .card-description {
    font-size: 10px;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .btn-ver-invitacion {
    padding: 8px 0;
    font-size: 11px;
    border-radius: 6px;
  }

  .btn-ver-precios {
    padding: 6px 0;
    font-size: 9px;
    letter-spacing: 0.5px;
    border-radius: 6px;
  }
}
</style>